export const GET_SOLUTION_REQUEST = 'elements/GET_SOLUTION_REQUEST';
export const GET_SOLUTION_SUCCESS = 'elements/GET_SOLUTION_SUCCESS';
export const GET_SOLUTION_FAILURE = 'elements/GET_SOLUTION_FAILURE';